<template lang="html">
  <Card :style="{ width: isMobile ? '300px' : '350px' }">
    <CardHeader title="Net Worth Growth" slot="title" key="brokerage"></CardHeader>
    <Row type="flex" justify="center" align="middle" class="feature-card">
      <ChangeIndicatorTable style="height: 100%; width: 100%;" :tableData="tableData" :baseValue="baseValue"></ChangeIndicatorTable>
    </Row>
  </Card>
</template>

<script>
import ChangeIndicatorTable from './charts/ChangeIndicatorTable';
import CardHeader from './CardHeader';

export default {
  props: ['isMobile'],
  components: { ChangeIndicatorTable, CardHeader },
  data() {
    const baseValue = 2091830.28;
    return {
      baseValue,
      tableData: [
        { label: 'Last Month', value: (baseValue - (baseValue * 0.045)) },
        { label: 'Last Year', value: (baseValue - (baseValue * 0.18)) },
      ],
    };
  },
};
</script>

<style lang="css">
</style>



// WEBPACK FOOTER //
// src/components/NetWorthIndicator.vue